import { useRouteMatch } from "react-router-dom"

const checkoutPath = window.ROUTES
  ? window.ROUTES.find(route => route.kind === "H")?.path || "/"
  : "/"

export const useRouteMatchCheckout = () => useRouteMatch(checkoutPath)
